import { AlertService } from './../../service/alert.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Produtos } from 'src/app/model/produtos.model';
import { ProdutosService } from 'src/app/service/produtos.service';

@Component({
  selector: 'app-criar-produto',
  templateUrl: './criar-produto.component.html',
  styleUrls: ['./criar-produto.component.css']
})
export class CriarProdutoComponent implements OnInit {

  produto: Produtos = {
    vc_nome: '',
    bl_status: false
  }

  constructor(private service: ProdutosService, private router: Router, private alertService: AlertService) { }

  ngOnInit(): void {
  }

  cadastrar(): void {
    this.service.cadastrarService(this.produto).subscribe((resp) => {
      this.alertService.success();
      this.router.navigate(['configuracao/produtos']);

    })
  }

  cancel(){
    this.router.navigate(['configuracao/produtos']);
  }


}
